import { ChangeDetectorRef, Component } from '@angular/core';
import { ContentService } from '../../spartacus/services/content.service';
import { Observable, combineLatest } from 'rxjs';
import { CmsComponentData } from '@spartacus/storefront';
import { CmsBannerComponent, OccConfig } from '@spartacus/core';
import { map, take } from 'rxjs/operators';

@Component({
    selector: 'app-clinical-flucelvax-second',
    templateUrl: './clinical-flucelvax-second.component.html',
    styleUrls: ['./clinical-flucelvax-second.component.scss'],
    standalone: false
})
export class ClinicalFlucelvaxSecondComponent {
  thirdnode: Observable<any> = this.bannerComponent.data$;
  userLoggedIn: boolean = false;
  mergedObject2: any = [];
  selectedTabIndex: any = []; 
  study = [false,false];
  mergedObject1: any = [];
 isCollapsed: { [key: string]: boolean } = {
    study1: true,
    study2: true,
    study5: true,
    study6: true
  }; 
  onTabChange(event: any) {
    this.selectedTabIndex = event.index;
  }
  constructor(private accessService: ContentService, public bannerComponent: CmsComponentData<CmsBannerComponent>, protected config: OccConfig, private cd: ChangeDetectorRef) { }

  getImage1(image: any): string {
    return this.config.backend?.occ?.baseUrl + image.desktop.url;
  }
  openModal(): void {
    const modal = document.getElementById('adult_abandonedPop');
    if (modal) {
      modal.style.display = 'block';
      document.body.classList.add('modal-open');
    }
  }
  closeModal(): void {
    const modal = document.getElementById('adult_abandonedPop');
    if (modal) {
      modal.style.display = 'none';
      document.body.classList.remove('modal-open');
    }
  }

  toggleStudy(i: number) {
    this.study[i] = !this.study[i];
    const body = document.querySelector('body') as HTMLElement;
    const stickyfooter = document.querySelector('.safety-info') as HTMLElement;
    const screenWidth = window.innerWidth;

    // Hide stickyfooter if any popup is open, show if all are closed
    if (screenWidth <= 992) {
      if (stickyfooter) {
        if (this.study.some(open => open)) {
          stickyfooter.style.display = 'none';
        } else {
          stickyfooter.style.display = 'block';
        }
      }
    } 

    if (screenWidth <= 992) {
      if (this.study[i]) {
        body.style.overflowY = 'hidden';
        body.style.position = 'relative';
      } else {
        body.style.overflowY = 'auto';
      }
    } else {
      body.style.overflowY = 'auto';
    }
  }

  ngOnInit() {
    this.thirdnode.pipe(take(1)).subscribe(res => {
      this.clinicaltabs(res);
    });
  }

  clinicaltabs(res: any) {
  //   const tilesList = res.safetyProfiletList.split(" ");
  //   const observables = tilesList.map((el: any) => this.accessService.opeffeaturedResources(el));

  //   combineLatest(observables).pipe(
  //     map((results:any) => results.flat())
  //   ).subscribe((mergedResults: any) => {
  //     this.mergedObject2 = mergedResults;
  //     this.cd.detectChanges();
  //     console.log(this.mergedObject2);
  //   });
  // }
  const tilesList = res.safetyProfiletList.split(" ");
  this.accessService.opeffeaturedResources(tilesList).subscribe((res : any) => {
  //  this.mergedObject2 = res.component;
   this.mergedObject2 = tilesList.map((uid:any) => res.component.find((c: any) => c.uid === uid)).filter((c:any) => !!c);
   this.cd.detectChanges;
  });
}
getMobileImage(image: any): string {
  return this.config.backend?.occ?.baseUrl + image.mobile.url;
}
//for study1, study2 , study5, study6 toggle
toggleCollapse(event: Event, key: string): void {
    event.preventDefault();
    this.isCollapsed[key] = !this.isCollapsed[key];
  }
}
